import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import _ from 'lodash'
import consultation from './modules/consultation'
import {isMd} from "@/config";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    consultation
  },

  state: {
    isLoad: false,
    main: {},
    fleet: {},
    currentPage: '',
    deviceSize: {
      width: 0,
      height: 0
    },
    dealer: {},
    stockPolicy: JSON.parse(localStorage.getItem('stockPolicy')),
    currentLang: isMd ? 'ro' : 'uk',
    currentCountry: isMd ? 'md' : 'ua',
    globalData: ''
  },
  getters: {
    getStockPolicy: state => state.stockPolicy,
    getMain: state => state.main,
    getFleet: state => state.fleet,
    // scriptsHeadBody: state => state.main.scripts,
    isLoad: state => state.isLoad,
    getEnv: state => this.process.env.VUE_APP_API_URL,
    isMobile: state => state.deviceSize.width < 768,
    isTablet: state => state.deviceSize.width >= 768 && state.deviceSize.width < 1280,
    isDesktop: state => state.deviceSize.width >= 1280,
  },
  actions: {
    async fetchGlobalData ({ commit }) {
      try {
        const { data } = await window.axios.get('/global-data')
        // console.log(data)
        commit('setGlobalData', data)
      } catch (err) {
        console.error('FAILED: fetchGlobalData')
        console.error(err)
      }
    },

    async fetchGeneralData ({ getters, commit }) {
      try {
        const { data } = await window.axios.get('/service')

        const appendScriptsToHeadAndBody = (scripts) => {
          try {
            const range = document.createRange()
            const rangeBody = document.createRange()
            const head = document.getElementsByTagName('head')[0]
            const body = document.getElementsByTagName('body')[0]

            try {
              range.setStart(head)
              rangeBody.setStart(body)
            } catch (err) {
              range.setStart(head, 0) // - didn't work for moderately old iOS
              rangeBody.setStart(body, 0)
            }

            if (scripts.head.end) {
              head.appendChild(
                range.createContextualFragment(scripts.head.end)
              )
            }
            if (scripts.head.begin) {
              head.insertBefore(
                range.createContextualFragment(scripts.head.begin), head.firstChild
              )
            }

            if (scripts.body.begin) {
              body.insertBefore(
                rangeBody.createContextualFragment(scripts.body.begin), body.firstChild
              )
            }

            if (scripts.body.end) {
              body.appendChild(
                rangeBody.createContextualFragment(scripts.body.end)
              )
            }
          } catch (er) {
            console.log('er')
            console.log(er)
          }
        }
        commit('setGeneralData', data.data)
        appendScriptsToHeadAndBody(data.data.scripts)
      } catch (err) {
        if (_.isEmpty(getters.getStockPolicy)) {
          console.error('FAILED: fetchGeneralData')
          console.error(err)
          router.push({ name: 'not-found' })
        }
      } finally {
        commit('setIsLoad')
      }
    },
    async fetchFleetPageData ({ getters, commit }) {
      try {
        const { data } = await window.axios.get(router.currentRoute.fullPath)
        commit('setFleetPageData', data.data)
        commit('setGeneralData', data.data || data)
        return Promise.resolve(data)
      } catch (err) {
        console.log(err)
        if (_.isEmpty(getters.getStockPolicy)) {
          console.error('FAILED: fetchFleetPageData')
          console.error(err)
          router.push({ name: 'not-found' })
        }
        return Promise.reject(err)
      } finally {
        commit('setIsLoad')
      }
    },
    async submitServiceRequest (store, { submitUrl, form, formName }) {
      let params = {}
      if ((_.get(router, 'app.$route.query.dealerId') || _.get(router, 'app.$route.query.dealerName') || _.get(router, 'app.$route.query.dealer')) && formName !== 'fleet') {
        params = {
          iframe: 1
        }
      }
      const { data } = await window.axios.post(submitUrl, form, {
        params: params
      })
      return data
    },
    async getServiceRequest (store, { submitUrl, form, formName }) {
      let params = {}
      if ((_.get(router, 'app.$route.query.dealerId') || _.get(router, 'app.$route.query.dealerName') || _.get(router, 'app.$route.query.dealer')) && formName !== 'fleet') {
        // eslint-disable-next-line no-unused-vars
        params = {
          iframe: 1
        }
      }
      const { data } = await window.axios.get(submitUrl, form)
      return data
    },
    async fetchPolicyPageData () {
      try {
        const { data } = await window.axios.get('/policy')
        return data.data
      } catch (err) {
        console.error('FAILED: fetchPolicyPageData')
        console.error(err)
        router.push({ name: 'not-found' })
      }
    },
    async fetchThankYouPageData () {
      try {
        const { data } = await window.axios.get('/thank-you')
        return data.data
      } catch (err) {
        console.error('FAILED: fetchThankYouPageData')
        console.error(err)
        router.push({ name: 'not-found' })
      }
    }
  },
  mutations: {
    setGlobalData (state, payload) {
      state.globalData = payload
    },
    setCurrentLang (state, payload) {
      state.currentLang = payload.toLowerCase()
      window.axios.defaults.headers.common['Accept-Language'] = payload
    },
    setCurrentCountry (state, payload) {
      state.currentCountry = payload.toLowerCase()
    },
    setGeneralData (state, newGeneralData) {
      state.main = newGeneralData
    },
    setFleetPageData (state, newFleetPageData) {
      state.fleet = newFleetPageData
    },
    setDeviceWidth (state, width) {
      state.deviceSize.width = width
    },
    setIsLoad (state) {
      clearInterval(window.titleChangeFn)
      window.document.title = _.get(state, 'main.title', '') || _.get(state, 'fleet.title', '') || 'no title'
      state.isLoad = true
    },
    setIsLoadFleet (state) {
      clearInterval(window.titleChangeFn)
      window.document.title = state.fleet.title || 'no title'
      state.isLoad = true
    },
    setDeviceHeight (state, height) {
      state.deviceSize.height = height
    },
    setStockPolicy (state, payload) {
      state.stockPolicy = payload
    },
    clearStockPolicy (state) {
      state.stockPolicy = {}
    },
    SET_DEALER (state, data) {
      state.dealer = { ...data }
    }
  }
})
